export default `
query clinics($url: String) {
	clinics(url: $url) {
    items {
      id
      name
      address
      city
      latitude
      longitude
      opening_hours {
        html
      }
      phone_number
      post_code
      region
      website
      chain {
        id
        name
      }
    }
	}
}
`;
